<template>
  <div>
    <section class="coursepage-section-2">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="toolbar-wrapper-2">
                        <ul class="toolbar-btn nav nav-tabs">
                            <li><a class="active" href="#grid" data-toggle="tab"><i class="icon_grid-2x2"></i>共 {{intTotal}} 场考试记录</a></li>
                        </ul>
                        <div class="sorting">
                            <p>考试科目:</p>
                            <select name="orderby" class="orderby" v-model="searchSub">
                                <option value="" selected="selected">所有科目</option>
                                <option :value="paperSub" v-for="(paperSub,index) in paperSubs" :key="index">{{paperSub}}</option>
                            </select>
                        </div>
                        <div class="search-box" method="post" action="#">
                            <input type="search" v-model="searchWords" placeholder="输入关键字...">
                            <button type="submit"  @click="toPage(0)" ><i class="ti-search"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab2">
                            <div class="row course-block course-list-block">
                                <div class="col-lg-12" v-for="(exam,index) in exams" :key="index">
                                    <div class="course-item" v-if="exam.testPaper">
                                        <div class="course-content" style="width: 100%;border-left:1px solid rgba(127, 136, 151, 0.2);">
                                            <p class="course__label">
                                                <span :class="getExamState(exam).class">{{getExamState(exam).txt}}</span>
                                                <!-- <a href="#" class="course__collection-icon" data-toggle="tooltip" data-placement="top" title="Add to Wishlist"><span class="la la-heart-o"></span></a> -->
                                            </p>
                                            <h3 class="course__title">
                                                <a>{{exam.testPaper.title}}</a>
                                            </h3>
                                            <p class="course__author">
                                              <a style="margin-right:10px">开始考试时间:{{exam.ctime}}</a>  <a>提交时间:{{!exam.etime?'无':exam.etime}}</a>
                                            </p>
                                            <div class="rating-wrap d-flex">
                                                
                                                <span class="star-rating-wrap">
                                                    <span class="star__rating">{{exam.testPaper.examinee.join(",")}} &nbsp;&nbsp;&nbsp;</span>
                                                    <span class="star__count">{{exam.testPaper.papertype=='test'?'模拟测试':'竞聘考试'}}</span>
                                                </span>
                                            </div><!-- end rating-wrap -->
                                            <div class="course-meta">
                                                <ul class="course__list d-flex">
                                                    <li>
                                                        <span class="meta__date">
                                                             正确/错误：{{!exam.examAchieveMent?'0':exam.examAchieveMent.correct}}/{{!exam.examAchieveMent?'0':exam.examAchieveMent.error}}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span class="meta__date">
                                                            得分/总分：{{!exam.examAchieveMent?'0':exam.examAchieveMent.score}}/{{exam.testPaper.totalscore}}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div><!-- end course-meta -->
                                            <div class="course-price-wrap">
                                                <span class="course__price"><i class="la la-clock-o"></i>耗时：{{!exam.ctime||!exam.etime?'00:00:00': getTimediff(exam.ctime.replace(/\./g,'/'), exam.etime.replace(/\./g,'/'))}}</span>
                                                <router-link class="course__btn" v-if="getExamState(exam).class!='course__label-text_error'" :to="`/achieveview/${exam._id}`">查看试卷</router-link>
                                                <router-link class="course__btn" style="color:red" v-else :to="global.isPhone()?`/exam/${exam.testpaperid}`:`/exampc/${exam.testpaperid}`">继续考试</router-link>
                                            </div><!-- end course-price-wrap -->
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-12 -->
                            </div>
                        </div>
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                           <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
               
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
    </section>

  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        exams:[],
        plateId:"",
        searchType:"",
        paperSubs:[],
        searchWords:"",
        searchSub:""
    };
  },

  components: {},

  computed: {
      
  },
  watch:{
      searchType(newVal){
          if(newVal)
          {
              this.toPage(0);
          }
      }
  },
  mounted() {
    this.$axios.get(`/api/examRecords?page=1&limit=6&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.exams=res.data.data;
            this.intTotal = res.data.total;
        }
    });
    this.$axios.get("/api/auth/me").then(res => {
            let arrhasCourse = [];
            for (var i = 0; i <res.data.data.needexaminee.length; i++)
            {
              arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
            }
            this.paperSubs = arrhasCourse;
        })
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      setSearchSubs(searchSub){
          this.searchSub = searchSub;
      },
      toPage(intcount){
        if(intcount)this.intCurrent = intcount;
        var searchConditions = "";
        if(this.searchType)
        {
          searchConditions+="&testpapertype="+this.searchType;
        }
        if(this.searchWords)
        {
          searchConditions+="&testpapertitle=$regex:"+this.searchWords;
        }
        if(this.searchSub){
          searchConditions+="&testpaperexaminee="+this.searchSub;
        }
        this.$axios.get(`/api/examRecords?page=${this.intCurrent}&limit=6&sort=-createdAt${searchConditions}`).then((res) => {
            if (res.data) {
                this.intTotal =res.data.total;
                this.exams = res.data.data;
                 this.toTop();
            }
        });
      },
      getTimediff(starttime, endtime){
            console.log(starttime)
            let start = new Date(starttime);
            let end = new Date(endtime);
            let time = end - start;
            console.log(time);
            //计算出相差天数
            var days=Math.floor(time/(24*3600*1000))
            
            //计算出小时数

            var leave1=time%(24*3600*1000)    //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))
            //计算相差分钟数
            var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))
            //计算相差秒数
            var leave3=leave2%(60*1000)      //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            return `${('00'+hours).slice(-2)}:${('00'+minutes).slice(-2)}:${('00'+seconds).slice(-2)}`
        },
      dateFormat(date, format){
            var o = {
            "M+" : date.getMonth()+1, //month
            "d+" : date.getDate(), //day
            "h+" : date.getHours(), //hour 24
            "H+" : date.getHours(), //hour 24
            "m+" : date.getMinutes(), //minute
            "s+" : date.getSeconds(), //second
            "q+" : Math.floor((date.getMonth()+3)/3), //quarter
            "S" : date.getMilliseconds() //millisecond
            };

            if(/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            }

            for(var k in o) {
                if(new RegExp("("+ k +")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
                }
            }
            return format;
        },
        getExamTimes(times){
            switch(times)
            {
                case "0":
                    return "不可补考";
                case "1":
                    return "可补考一次";
                case "2":
                    return "不限次数"
            }
        },
         NewDate(str){ 
            if(!str){
                return 0;
            }
            let arr=str.split(" ");
            let d=arr[0].split("-");
            let t=arr[1].split(":");
            var date = new Date();
            date.setUTCFullYear(d[0], d[1] - 1, d[2]);
            date.setUTCHours(t[0], t[1], t[2], 0);
            return date;
        },
        getExamState(exam){
            var objrecord ={};
            switch(exam.state) {
                case "complete":
                    if(exam.examAchieveMent)
                    {
                        objrecord.txt = "完成";
                        objrecord.class = "course__label-text";
                    }else{
                        objrecord.txt = "待批改";
                        objrecord.class = "course__label-text_warning"
                    }
                    break;
                case "fail":
                    objrecord.txt = "未提交";
                    objrecord.class = "course__label-text_failed"
                    break;
                case "edit":
                    objrecord.txt = "正在进行";
                    objrecord.class = "course__label-text_error"
                    break;
                default:
                    objrecord.txt = "未提交";
                    objrecord.class = "course__label-text_failed"
                    break;
            }
            return objrecord;
        },
  }
}

</script>
<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #6510AD;
}
::v-deep .el-pager li.active{
    color: #6510AD;
}



/*-===============================
    COURSE AREA
===============================-*/
 .course-content-wrapper {
  background-color: #ffffff;
  /* padding-top: 80px; */
  /* padding-bottom: 115px; */
      font-size: 16px;
    line-height: 22px;
    font-family: "Libre Franklin", sans-serif;
    color: #7f8897;
    position: relative;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

 .course-tab-wrap .course-tab-list.nav-tabs {
  border: none;
  margin-top: 36px;
  margin-bottom: 60px;
}

 .course-tab-wrap .course-tab-list.nav-tabs li {
  margin: 0 1px;
}

 .course-tab-wrap .course-tab-list.nav-tabs li a {
  color: #7f8897;
  text-transform: capitalize;
  font-weight: 500;
  display: block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 8px 17px;
  position: relative;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

 .course-tab-wrap .course-tab-list.nav-tabs li a.active {
  background-color: #6510AD;
  color: #fff;
}

 .course-tab-wrap .course-tab-list.nav-tabs li a.active:hover {
  background-color: #6510AD;
  color: #fff;
}

 .course-tab-wrap .course-tab-list.nav-tabs li a:hover {
  background-color: rgba(81, 190, 120, 0.1);
  color: #6510AD;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {

   .tab-content .course-block .col-lg-4,
   .tab-content .course-block .col-lg-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}

 .button-shared {
  margin-top: 28px;
}


/*============ course-block ============*/
.course-block .course-item {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.course-block .course-item .course-img {
  position: relative;
}

.course-block .course-item .course-img .course__img {
  display: block;
}

.course-block .course-item .course-img .course__img img {
  width: 100%;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.course-block .course-item .course-img .course-tooltip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.course-block .course-item .course-img .course-tooltip .tooltip-label {
  background-color: #6510AD;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 4px 0;
  -moz-border-radius: 4px 4px 4px 0;
  border-radius: 4px 4px 4px 0;
  font-size: 12px;
  position: relative;
}

.course-block .course-item .course-img .course-tooltip .tooltip-label:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 6px;
  z-index: -1;
  background-color: #6510AD;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skew(12deg, 0deg);
  -moz-transform: skew(12deg, 0deg);
  -ms-transform: skew(12deg, 0deg);
  -o-transform: skew(12deg, 0deg);
  transform: skew(12deg, 0deg);
  -webkit-border-radius: 4px 0 0 0;
  -moz-border-radius: 4px 0 0 0;
  border-radius: 4px 0 0 0;
}


.course-block .course-item .course-img .course-buytip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.buytip-label {
  background-color: #ff0800;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 4px 0;
  -moz-border-radius: 4px 4px 4px 0;
  border-radius: 4px 4px 4px 0;
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 58px;
  z-index: 1;
}

.buytip-label:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  right: 6px;
  z-index: -1;
  background-color: #ff0000;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skewX(351deg);
  -moz-transform: skewX(351deg);
  -ms-transform: skewX(351deg);
  -o-transform: skewX(351deg);
  transform: skewX(351deg);
  -webkit-border-radius: 4px 0 0 0;
  -moz-border-radius: 4px 0 0 0;
  border-radius: 4px 0 0 0;
}

/* .course-block .course-price-wrap .course-xstip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
} */

.course-block .course-price-wrap .course-xstip .xstip-label {
  background-color: #ef2923;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 2px 10px 2px 10px;
  -webkit-border-radius: 4px 4px 4px 0;
  -moz-border-radius: 4px 4px 4px 0;
  border-radius: 0px 4px 4px 0px;
  font-size: 12px;
  position: relative;
  margin-left: -30px;
  margin-right: 8px;
  /* right: 16px; */
  /* bottom: 58px; */
  z-index: 1;
}

.course-block .course-item .course-img:after {
  position: absolute;
  bottom: 0;
  left: 30px;
  content: '';
  width: 0;
  height: 0;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 13px solid #fff;
}

.course-block .course-item .course-content {
  border: 1px solid rgba(127, 136, 151, 0.2);
  -webkit-border-radius: 0 0 4px 4px;
  -moz-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
  padding: 29px 30px 30px 30px;
  /* border-top: transparent; */
}

.course-block .course-item .course-content .course__label {
  font-weight: 500;
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.course-block .course-item .course-content .course__label .course__label-text {
  background-color:rgb(232 217 244);
  display: inline-block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: #6510AD;
  padding: 3px 10px;
  text-transform: capitalize;
  font-size: 15px;
}

.course-block .course-item .course-content .course__label .course__label-text_warning {
  background-color: rgba(81, 190, 120, 0.1);
  display: inline-block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: #E6A23C;
  padding: 3px 10px;
  text-transform: capitalize;
  font-size: 15px;
}

.course-block .course-item .course-content .course__label .course__label-text_failed {
  background-color: rgba(81, 190, 120, 0.1);
  display: inline-block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: #909399;
  padding: 3px 10px;
  text-transform: capitalize;
  font-size: 15px;
}

.course-block .course-item .course-content .course__label .course__label-text_error {
  background-color: rgba(81, 190, 120, 0.1);
  display: inline-block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: #F56C6C;
  padding: 3px 10px;
  text-transform: capitalize;
  font-size: 15px;
}

.course-block .course-item .course-content .course__label .course__collection-icon {
  margin-left: auto;
  color: #7f8897;
  font-size: 22px;
  position: relative;
}

.course-block .course-item .course-content .course__label .course__collection-icon:after {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  content: "\f233";
  font-family: "LineAwesome";
  color: #6510AD;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  opacity: 0;
  visibility: hidden;
}

.course-block .course-item .course-content .course__label .course__collection-icon:hover:after {
  opacity: 1;
  visibility: visible;
}

.course-block .course-item .course-content .course__title {
  font-size: 22px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 9px;
  line-height: 28px;
}

.course-block .course-item .course-content .course__title a {
  color: #233d63;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.course-block .course-item .course-content .course__title a:hover {
  color: #6510AD;
}

.course-block .course-item .course-content .course__author a {
  color: #7f8897;
  text-transform: capitalize;
  font-weight: 500;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.course-block .course-item .course-content .course__author a:hover {
  color: #6510AD;
}

.course-block .course-item .course-content .rating-wrap {
  margin-top: 8px;
  font-size: 15px;
  margin-bottom: 20px;
}

.course-block .course-item .course-content .rating-wrap .review-stars li {
  margin-right: 2px;
}

.course-block .course-item .course-content .rating-wrap .review-stars li span {
  color: #F68A03;
}

.course-block .course-item .course-content .rating-wrap .star-rating-wrap {
  color: #233d63;
  font-weight: 500;
}

.course-block .course-item .course-content .rating-wrap .star-rating-wrap .star__rating {
  margin: 0 1px 0 3px;
}

.course-block .course-item .course-content .course-meta {
  margin-bottom: 25px;
}

.course-block .course-item .course-content .course-meta .course__list li {
  width: 100%;
  border-right: 1px solid rgba(127, 136, 151, 0.2);
  padding: 0 15px;
}

.course-block .course-item .course-content .course-meta .course__list li:first-child {
  padding-left: 0;
}

.course-block .course-item .course-content .course-meta .course__list li:last-child {
  border-right: none;
  padding-right: 0;
  text-align: right;
}

.course-block .course-item .course-content .course-meta .course__list li span {
  display: block;
}

.course-block .course-item .course-content .course-meta .course__list li span.meta__date {
  color: #233d63;
  font-weight: 500;
}

.course-block .course-item .course-content .course-meta .course__list li span.meta__text {
  font-weight: 500;
  font-size: 15px;
}

.course-block .course-item .course-content .course-price-wrap {
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.course-block .course-item .course-content .course-price-wrap .course__price {
  color: #ff0000;
  font-weight: 400;
  font-size: 17px;
}

.course-block .course-item .course-content .course-price-wrap .course__price .course__before-price {
  font-size: 16px;
  margin-right: 3px;
  color: #7f8897;
  text-decoration: line-through;
}

.course-block .course-item .course-content .course-price-wrap .course__btn {
  margin-left: auto;
  color: #7f8897;
  font-weight: 500;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  text-decoration: underline;
  color: #6510AD;
}

.course-block .course-item .course-content .course-price-wrap .course__btn:hover {
  color: red;
}

.course-block .course-item:hover {
  -webkit-box-shadow: 0 0 40px rgba(82, 85, 90, 0.1);
  -moz-box-shadow: 0 0 40px rgba(82, 85, 90, 0.1);
  box-shadow: 0 0 40px rgba(82, 85, 90, 0.1);
}


/*-===============================
    COURSE AREA 4
===============================-*/
.course-area4 {
  padding-top: 110px;
}

.course-area4 .course-tab-wrap {
  background-color: #fff;
  border: 1px solid rgba(127, 136, 151, 0.2);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 20px 20px;
}

.course-area4 .course-tab-wrap .course-tab-list.nav-tabs {
  margin: 0;
}

@media (max-width: 480px) {
  .course-area4 .course-tab-wrap .course-tab-list.nav-tabs {
    margin-bottom: 30px;
    -ms-flex-pack: center;
    justify-content: center;
  }
}

.course-area4 .course-tab-wrap .course-tab-list.nav-tabs li {
  margin-left: 0;
  margin-right: 5px;
}

.course-area4 .course-tab-wrap .course-tab-list.nav-tabs li:nth-child(2) {
  margin-right: 15px;
}

.course-area4 .course-tab-wrap .course-tab-list.nav-tabs li a {
  font-size: 22px;
  padding: 0;
}

.course-area4 .course-tab-wrap .course-tab-list.nav-tabs li a span {
  padding: 7px 12px;
  z-index: 1;
}

@media (max-width: 480px) {
  .course-area4 .course-tab-wrap .course-filter1 .courses-ordering {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .course-area4 .course-tab-wrap.d-flex {
    display: block !important;
  }
}

.course-area4 .course-item-wrap .tab-content .course-list-block .course-item {
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item {
    width: 100%;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item {
    width: 100%;
  }
}

@media (max-width: 425px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item {
    display: block;
  }
}

.course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img {
  width: 40%;
}

@media (max-width: 425px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img {
    width: 100%;
  }
}

.course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img .course__img img {
  height: 304px;
  object-fit: cover;
  -webkit-border-radius: 4px 0 0 4px;
  -moz-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img .course__img img {
    height: 355px;
  }
}

@media (max-width: 425px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img .course__img img {
    height: auto;
    -webkit-border-radius: 4px 4px 0 0;
    -moz-border-radius: 4px 4px 0 0;
    border-radius: 4px 4px 0 0;
  }
}

.course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img:after {
  bottom: auto;
  top: 35px;
  left: auto;
  right: -7px;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

@media (max-width: 425px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-img:after {
    top: auto;
    left: 30px;
    bottom: 0;
    right: auto;
    -webkit-transform: rotate(0);
    -moz-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
}

.course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-content {
  width: 60%;
  border-left: transparent;
  border-top: 1px solid rgba(127, 136, 151, 0.2);
  -webkit-border-radius: 0 4px 4px 0;
  -moz-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}

@media (max-width: 425px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-content {
    width: 100%;
  }
}

@media (max-width: 425px) {
  .course-area4 .course-item-wrap .tab-content .course-list-block .course-item .course-content {
    /* border-top: transparent; */
    -webkit-border-radius: 0 0 4px 4px;
    -moz-border-radius: 0 0 4px 4px;
    border-radius: 0 0 4px 4px;
    border-left: 1px solid rgba(127, 136, 151, 0.2);
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .course-area4 .course-item-wrap .tab-content .course-block .course-item {
    width: 100%;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .course-area4 .course-item-wrap .tab-content .course-block .course-item {
    width: 100%;
  }
}

.course-area4 .course-content-wrapper {
  padding-top: 30px;
  background-color: transparent;
}

/*-========= course-filter1 =========-*/

.course-filter1 .courses-ordering {
  position: relative;
  width: 200px;
}

.course-filter1 .courses-ordering .target-course {
  width: 100%;
  border: 1px solid rgba(127, 136, 151, 0.2);
  padding: 15px 0 15px 20px;
  font-size: 16px;
  color: #7f8897;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  cursor: pointer;
  outline: none;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background-color: transparent;
  font-weight: 500;
}

.course-filter1 .courses-ordering:before {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  font-family: "LineAwesome";
  font-size: 15px;
  color: #7f8897;
  pointer-events: none;
  display: inline-block;
  content: "\f110";
  right: 13px;
}

ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
        width: 100%;
}
dl, ol, ul {
    margin-top: 0;
    margin-bottom: 1rem;
}
a:not([href]):not([tabindex]) {
    color:inherit !important
}
</style>